module["exports"] = [
  "!##-!##-####",
  "(!##) !##-####",
  "1-!##-!##-####",
  "!##.!##.####",
  "!##-!##-####",
  "(!##) !##-####",
  "1-!##-!##-####",
  "!##.!##.####",
  "!##-!##-#### x###",
  "(!##) !##-#### x###",
  "1-!##-!##-#### x###",
  "!##.!##.#### x###",
  "!##-!##-#### x####",
  "(!##) !##-#### x####",
  "1-!##-!##-#### x####",
  "!##.!##.#### x####",
  "!##-!##-#### x#####",
  "(!##) !##-#### x#####",
  "1-!##-!##-#### x#####",
  "!##.!##.#### x#####"
];



//////////////////
// WEBPACK FOOTER
// ./node_modules/faker/lib/locales/en/phone_number/formats.js
// module id = 2609
// module chunks = 1609